import { render, staticRenderFns } from "./fileImg.vue?vue&type=template&id=fcf3085e&scoped=true&"
import script from "./fileImg.vue?vue&type=script&lang=js&"
export * from "./fileImg.vue?vue&type=script&lang=js&"
import style0 from "./fileImg.vue?vue&type=style&index=0&id=fcf3085e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf3085e",
  null
  
)

export default component.exports